import { render } from "./ProductFamilyItem.vue?vue&type=template&id=62aea225&scoped=true"
import script from "./ProductFamilyItem.vue?vue&type=script&lang=js"
export * from "./ProductFamilyItem.vue?vue&type=script&lang=js"

import "./ProductFamilyItem.vue?vue&type=style&index=0&id=62aea225&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aea225"]])

export default __exports__